import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.panelTarget.focus()
    document.documentElement.classList.add("modal-open")
  }

  disconnect() {
    document.documentElement.classList.remove("modal-open")
  }

  close() {
    this.element.closest("turbo-frame").innerHTML = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }
}
